import * as dayjs from 'dayjs'
import * as localizedFormat from 'dayjs/plugin/localizedFormat'

import type { DayjsFormat } from '../../models'

dayjs.extend(localizedFormat)

export const format = (format: DayjsFormat, date: Date | string): string => dayjs(date).format(format)
